module.exports = __webpack_public_path__ + "img/hero-fire-04.004c5a3f.png";